import { gql } from '@apollo/client'

export const GET_COMPANY_BY_NAME = gql`
  query GetCompanyByName($name: String!) {
    companyByName(name: $name) {
      name
      id
      companyUpcs
    }
  }
`
